import { Table, Stack, TableBody, TableCell, TableContainer, Avatar, TableHead, Tabs, Tab, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar, createFilterOptions, Chip } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useVendorEnquiryIDByDepartmentID from "../../../hooks/useVendorEnquiryIDByDepartmentID";
import useLoadVendorQuotationDetailByVendor from "../../../hooks/useLoadVendorQuotationDetailByVendor";
import useVendorQuotationCRUD from "../../../hooks/useVendorQuotationCRUD";
import VendorResponseActionMenu from "./VendorResponseSubMenu";

import useGetVendorEnquiryDetByPurchaseID from "../../../hooks/useGetVendorEnquiryDetByPurchaseID";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CompareQuotations from "../vendor-quotation-comparision/CompareQuotations";
import { toast } from "react-toastify";
import CustomAutocomplete from "../../../pages/commancomponents/customAutoComplete";
import VendorResponseSubMenuNew from "./VendorResponseSubMenuNew";
import AddCompareVendorQuotations from "../vendor-quotation-comparision/AddCompareVendorQuotations";
const filter = createFilterOptions();
const isRowEditable = (status) => status === "pending";
const getStatusStyle = (status) => {
    switch (status) {
        case "in_comparison":
            return {
                label: "In Comparison",
                // bg: "#A5D6A7",     // light green
                color: "#A5D6A7",  // dark green
            };

        case "converted":
            return {
                label: "Converted",
                // bg: "#A5D6A7",
                color: "#A5D6A7",
            };

        case "pending":
            return {
                label: "Pending",
                // bg: "#FFE0B2",
                color: "#FFE0B2",
            };

        default:
            return {
                label: status,
                // bg: "#E0E0E0",
                color: "#E0E0E0",
            };
    }
};


const AddVendorReponseNew = ({ handlecallback, editIssueIndentID: editPurchaseIndentID, para_selectedDepartment, para_selectedPurchaseIndentNo, selectedMode, selectedRows, selectedpurchaseindentID, editresponsehdrid, selectedQuoteDetails, fromVendorEnquiryUI = false }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const today = dayjs().startOf('day');

    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [openPreviewModal, setOpenPreviewModal] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);
    const { vendorIDList, selectedVendoIdList, selectedVendoIdListID, setSelectedVendoIdList, setSelectedVendoIdListID, loadVenodrIDByDepartmentID, loadVenodrListByEnquiryIDLocal, vendorList, selectedVendoList, selectedVendoListID, setSelectedVendoList, setSelectedVendoListID } = useVendorEnquiryIDByDepartmentID(0);

    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);

    const { requestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
    const { VendorQuotationDetails, loadVendorDetailByVendorID, } = useLoadVendorQuotationDetailByVendor();
    const { vendorEnquiryDet, setvendorEnquiryDet, loadVendorEnquiryDet } = useGetVendorEnquiryDetByPurchaseID();
    const [partyList, setPartyList] = useState([]);
    const [filteredParties, setFilteredParties] = useState([]); // filtered ones from indent
    const [isPartyDisabled, setIsPartyDisabled] = useState(true); // control disable
    const [requestDate, setRequestDate] = useState(dayjs());

    const [selectedPartyID, setSelectedPartyID] = useState(0);
    const [selectedParty, setSelectedParty] = useState(null);
    const [storeNotes, setStoreNotes] = useState('');



    const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);


    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(dayjs());


    const [paymentTerms, setPaymentTerms] = useState([]);

    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
    const [paymentTermFilterText, setPaymentTermFilterText] = useState('');

    const [paymentTermsID, setPaymentTermsID] = useState(0);

    const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);
    const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);

    const [discountID, setDiscountID] = useState(0);
    const [tcsID, setTCSID] = useState(0);

    const [freight, setFreight] = useState(null);
    const [cgst, setCgst] = useState(0);
    const [sgst, setSgst] = useState(0);

    const [discount, setDiscount] = useState(null);
    const [discounts, setDiscounts] = useState([]);
    const [isDiscounts, setIsDiscounts] = useState(false);

    const [inputValue, setInputValue] = useState('');

    const [tds, setTds] = useState(null);
    const [dTDS, setDTDS] = useState(0); // calculated TDS value
    const [tdsID, setTDSID] = useState(null); // if needed
    const [tdsOptions, settdsOptions] = useState([]);
    const handleOpenMenu = (setter) => (event) => {
        setter(event.currentTarget);
    };

    const handleCloseMenu = (setter) => () => {
        setter(null);
    };

    const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
        setSelectedOption(option);
        setSelectedID(option ? option.id : null);
        handleCloseMenu();
    };

    // Discount
    useEffect(() => {
        const para = { p_companyid: 1 };

        callApi(
            API_ENDPOINTS.DISCOUNT_LIST,
            'POST',
            { 'Content-Type': 'application/json' },
            para
        )
            .then(data => {
                if (data?.length) {
                    setDiscounts(data);


                }
            })
            .catch(err => alert('error', err.message, 'Error'));
    }, [discountID]);





    const handleAddOption = (label) => () => {
        if (label === 'Payment Term') {
            setPaymentTermDialogOpen(true);
        }
    };

    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };


    const { processIndent } = useVendorQuotationCRUD(callMessage);
    const hasLoadedRequestDetails = useRef(false);
    const hasLoadedVendorDetails = useRef(false);

    const [openVendorQuotation, setOpenVendorQuotation] = useState(true);
    const [openVendorCompareQuotation, setOpenVendorCompareQuotation] = useState(false);

    const [tableRows, setTableRows] = useState([{ id_material: 0, material_code: '', material_description: '', quantity_required: 0, vendor_offered_qty: 0, quoted_price: 0, party_name: '', delivery_date: '', payment_terms: 0, cgst_rate: 0, cgst_amount: 0, sgst_rate: 0, sgst_amount: 0, igst_rate: 0, igst_amount: 0, amount: 0, total: 0, rating: '', id_party: 0, status: 'pending' }]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    //const isDisabled = selectedQuoteDetails?.status !== "pending";

    const isDisabled = selectedQuoteDetails[0]?.length > 0 && selectedQuoteDetails[0].status !== "pending";

    const [isDisabled2, setIsDisabled2] = useState(false);
    const getRequestDetailByRequestID = async (id_request) => {

        await loadVenodrIDByDepartmentID(selectedDepartmentID, null, id_request);

    }


    useEffect(() => {
        if (!isPaymentTermsLoaded) {
            const para = {
                p_companyid: 1,
                p_mode: 1
            }
            callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) { setPaymentTerms(data); }
                })
                .catch(error => { alert('error', error.message, 'Error'); });
        }
    }, [isPaymentTermsLoaded, isPaymentTermDialogOpen]);



    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPartyList(data);
                        setFilteredParties([]); // initially empty
                        setIsPartyDisabled(true); // initially disabled
                    }
                })
                .catch(error => {
                    alert('error', error.message, 'Error');
                });
        }



    }, [isDataLoaded]);

    useEffect(() => {
        if (fromVendorEnquiryUI) {
            if (selectedRequestIndentNumberList && selectedRequestIndentNumberList.id_request && partyList.length > 0) {
                handlePurchaseIndentChange(selectedRequestIndentNumberList);
            }

        }
    }, [fromVendorEnquiryUI, selectedRequestIndentNumberList, partyList]);


    const prepareTableRowsByParty = (party) => {
        if (!VendorQuotationDetails || VendorQuotationDetails.length === 0) return;

        // Step 1: Format delivery_date
        const formattedData = VendorQuotationDetails.map((item) => {
            const rawDate = item.delivery_date;

            const isInvalidDate =
                !rawDate ||
                rawDate === '0001-01-01T00:00:00' ||
                rawDate === '0001-01-01';

            return {
                ...item,
                vendor_offered_qty: item.vendor_offered_qty ?? 0, // ✅ add default
                delivery_date: isInvalidDate
                    ? null
                    : dayjs(rawDate).format('DD-MMM-YYYY')
            };
        });



        // Step 2: If party is selected, filter by party ID in id_party_list
        if (party) {
            const filteredData = formattedData.filter(
                item => item.id_party_list && item.id_party_list.includes(party.id)
            );
            setTableRows(filteredData);
        }
        // Step 3: Party cleared → reset editable fields
        else {
            const resetData = formattedData.map(item => ({
                ...item,
                quoted_price: 0,
                delivery_date: '',
                payment_terms: '',
                rating: '',
                id_party: 0,
                vendor_offered_qty: 0,
                status: 'pending'
            }));
            setTableRows(resetData);
        }
    };


    useEffect(() => {
        if (para_selectedDepartment) {
            setSelectedDepartment(para_selectedDepartment);
            loadVenodrIDByDepartmentID(para_selectedDepartment.id, 'vendor enquiry');
        }
    }, [loadVenodrIDByDepartmentID, para_selectedDepartment, setSelectedDepartment]);


    useEffect(() => {
        if (!hasLoadedRequestDetails.current && para_selectedPurchaseIndentNo && para_selectedPurchaseIndentNo.id_request) {
            setSelectedRequestIndentNumberList(para_selectedPurchaseIndentNo);
            setSelectedRequestIndentNumberListID(para_selectedPurchaseIndentNo.id_request);
            getRequestDetailByRequestID(para_selectedPurchaseIndentNo.id_request);

            hasLoadedRequestDetails.current = true; // prevent future runs
        }
    }, [para_selectedPurchaseIndentNo]);

    useEffect(() => {
        if (selectedpurchaseindentID) {
            loadVendorEnquiryDet(selectedpurchaseindentID);
        }
    }, [selectedpurchaseindentID]);




    useEffect(() => {
        if (!editPurchaseIndentID) return;
        if (hasLoadedVendorDetails.current) return;

        // 1️⃣ Set vendor enquiry ID
        setSelectedVendoIdListID(editPurchaseIndentID);

        // 2️⃣ Load vendor quotation detail (API)
        loadVendorDetailByVendorID(editPurchaseIndentID, editresponsehdrid);

        // 3️⃣ Basic form values (safe, no dependency on lists)
        setRequestDate(dayjs(selectedRows?.response_date || new Date()));
        setStoreNotes(selectedRows?.remarks || '');
        setFreight(selectedRows?.fright || '');
        setExpectedDeliveryDate(selectedRows?.expiry_delivery_date || null);

        // 4️⃣ Party (only ID for now)
        setSelectedPartyID(selectedRows?.id_party || 0);

        // 🔒 LOCK IT
        hasLoadedVendorDetails.current = true;

    }, [editPurchaseIndentID]);


    useEffect(() => {
        if (!selectedRows?.id_party || !partyList.length) return;

        const party = partyList.find(p => p.id === selectedRows.id_party);
        if (party) {

            setSelectedParty(party || null);
            setSelectedPartyID(selectedRows.id_party || 0);
        }
    }, [partyList]);


    useEffect(() => {
        if (!paymentTerms.length) return;

        const term = paymentTerms.find(t => t.id === selectedRows?.id_payment_terms);
        if (term) {
            setPaymentTermsID(term.id);
            setSelectedPaymentTerm(term);
        }
    }, [paymentTerms]);

    useEffect(() => {
        if (!tdsOptions.length) return;

        const tds = tdsOptions.find(t => t.id === selectedRows?.id_tds);
        if (tds) {
            setTDSID(tds.id);
            setTds(tds);
        }
    }, [tdsOptions]);

    useEffect(() => {
        if (!discounts.length) return;

        const disc = discounts.find(d => d.id === selectedRows?.id_discount);
        if (disc) {
            setDiscountID(disc.id);
            setDiscount(disc);
        }
    }, [discounts]);



    const calculateRowAmounts = (item) => {
        const rate = parseFloat(item.quoted_price) || 0;
        const quantity = parseFloat(item.quantity_required) || 0;

        const cgstRate = parseFloat(item.cgst_rate) || 0;
        const sgstRate = parseFloat(item.sgst_rate) || 0;
        const igstRate = parseFloat(item.igst_rate) || 0;

        const amount = rate * quantity;

        const cgst_amount = (amount * cgstRate) / 100;
        const sgst_amount = (amount * sgstRate) / 100;
        const igst_amount = (amount * igstRate) / 100;

        const total =
            amount + cgst_amount + sgst_amount + igst_amount;

        return {
            amount,
            cgst_amount: cgst_amount.toFixed(2),
            sgst_amount: sgst_amount.toFixed(2),
            igst_amount: igst_amount.toFixed(2),
            total: total.toFixed(2),
        };
    };


    useEffect(() => {
        const defaultRow = {
            id_material: 0,
            material_code: '',
            material_description: '',
            quantity_required: 0,
            quoted_price: 0,
            party_name: '',
            delivery_date: '',
            payment_terms: 0,
            rating: '',
            id_party: 0,
            status: 'pending'
        };

        let incomingData = selectedRows?.details;

        // 🔥 Parse it if it's a JSON string
        if (typeof incomingData === 'string') {
            try {
                incomingData = JSON.parse(incomingData);
            } catch (e) {
                console.error('Failed to parse selectedRows.details:', e);
                incomingData = [];
            }
        }

        const normalizedRows = Array.isArray(incomingData)
            ? incomingData
            : incomingData
                ? [incomingData]
                : [];

        const formattedRows = normalizedRows.map((item) => {
            const calculated = calculateRowAmounts(item);

            return {
                id_material: item.id_material || 0,
                material_code: item.material_code || '',
                material_description: item.material_description || '',
                quantity_required: item.quantity_required || 0,
                quoted_price: item.quoted_price || 0,
                party_name: item.party_name || '',
                delivery_date: item.delivery_date
                    ? dayjs(item.delivery_date).format('DD-MMM-YYYY')
                    : '',
                payment_terms: item.payment_terms || 0,
                rating: item.rating || '',
                id_party: item.id_party || 0,
                status: item.status || 'pending',

                cgst_rate: item.cgst_rate || 0,
                sgst_rate: item.sgst_rate || 0,
                igst_rate: item.igst_rate || 0,
                vendor_offered_qty: item.vendor_offered_qty || 0,

                ...calculated
            };
        });


        setTableRows(formattedRows.length > 0 ? formattedRows : [defaultRow]);
    }, [selectedRows]);




    const calculateRatings = (rows) => {
        const updatedRows = [...rows];
        const materialGroups = {};

        // Group rows by material code
        updatedRows.forEach(row => {
            const code = row.material_code;
            if (!materialGroups[code]) {
                materialGroups[code] = [];
            }
            materialGroups[code].push(row);
        });

        // Assign L1, L2, etc. based on lowest quoted_price per material
        Object.values(materialGroups).forEach(group => {
            // Sort by quoted price ascending
            group.sort((a, b) => a.quoted_price - b.quoted_price);

            // Assign ratings (L1, L2, ...)
            group.forEach((row, index) => {
                row.rating = `L${index + 1}`;
            });
        });

        return updatedRows;
    };


    useEffect(() => {
        if (tableRows && tableRows[0]?.id_material !== 0) {
            const ratedRows = calculateRatings(tableRows);

            const isSame =
                JSON.stringify(ratedRows) === JSON.stringify(tableRows); // ⚠️ not best for large data, but simple fix

            if (!isSame) {
                setTableRows(ratedRows);
            }
        }
    }, [tableRows]);




    const handleQuantityChange = (index, quoted_price) => {
        setTableRows(prevRows => {
            const newRows = [...prevRows];
            const row = { ...newRows[index] };

            const rate = parseFloat(quoted_price) || 0;
            const quantity = parseFloat(row.quantity_required) || 0;

            const cgstRate = parseFloat(row.cgst_rate) || 0;
            const sgstRate = parseFloat(row.sgst_rate) || 0;
            const igstRate = parseFloat(row.igst_rate) || 0;

            // Base amount
            const amount = rate * quantity;

            // GST calculations
            row.cgst_amount = ((amount * cgstRate) / 100).toFixed(2);
            row.sgst_amount = ((amount * sgstRate) / 100).toFixed(2);
            row.igst_amount = ((amount * igstRate) / 100).toFixed(2);

            // Final values
            row.quoted_price = rate;
            row.amount = amount;
            row.total = calculateAmount(quantity, rate, cgstRate, sgstRate, igstRate);

            newRows[index] = row;
            return newRows;
        });
    };



    const handleVendorOfferedQuantityChange = (index, qty) => {
        setTableRows(prevRows => {
            const newRows = [...prevRows];
            const row = { ...newRows[index] };

            let quantity = parseFloat(qty);

            // Handle invalid / empty input
            if (isNaN(quantity) || quantity < 0) {
                quantity = 0;
            }

            // Clamp quantity to not exceed quantity_required
            if (quantity > row.quantity_required) {
                quantity = row.quantity_required;
                callMessage(
                    'warning',
                    `Vendor quantity cannot exceed required quantity (${row.quantity_required})`,
                    'Validation'
                );
            }

            // Round to 2 decimals
            quantity = Math.round(quantity * 100) / 100;

            row.vendor_offered_qty = quantity;
            newRows[index] = row;
            return newRows;
        });
    };



    const callback = () => {
        handlecallback();
    }

    const handleSaveAndDraft = async () => {

        const missingFields = [];

        const modifiedRows = tableRows.map(({ material_code, material_description, ...rest }) => rest);

        let id_request = editresponsehdrid !== 0 ? editresponsehdrid : 0;
        let mode_id = editPurchaseIndentID !== 0 ? 1 : 0;

        if (selectedDepartment === null) {
            missingFields.push("Department")
        }

        if (selectedRequestIndentNumberListID === null) {
            missingFields.push("Purchase Indent")
        }


        if (!requestDate || !dayjs(requestDate).isValid()) {
            missingFields.push("Valid Response Date")
        }


        else if (dayjs(requestDate).isBefore(today)) {
            if (mode_id === 0) {
                missingFields.push("Response Date cannot be a past date")
            }

        }

        if (freight === '' || freight === null) {
            missingFields.push("Freight Value")
        }

        if (!expectedDeliveryDate || !dayjs(expectedDeliveryDate).isValid()) {
            missingFields.push("Valid Delivery Date")
        }
        else if (dayjs(expectedDeliveryDate).isBefore(today)) {

            if (mode_id === 0) {
                missingFields.push("Delivery Date cannot be a past date");
            }
        }

        if (!paymentTermsID) {
            missingFields.push("Payment Term")
        }

        if (!tdsID) {
            missingFields.push("TDS")
        }
        if (!selectedPartyID) {
            missingFields.push("Party Name")
        }



        const vendorofferqtyrows = modifiedRows.filter(item => item.vendor_offered_qty === 0);

        if (vendorofferqtyrows.length > 0) {
            missingFields.push("Some rows have 'Vendor Offered Quantity' value as 0. Please update those rows before saving.")
        }

        const invalidRows = modifiedRows.filter(item => item.quoted_price === 0);

        if (invalidRows.length > 0) {
            missingFields.push("Some rows have 'Quoted Price' value as 0. Please update those rows before saving.")
        }

        const gstMissingRows = modifiedRows.filter(row => {
    const cgst = Number(row.cgst_rate || 0);
    const sgst = Number(row.sgst_rate || 0);
    const igst = Number(row.igst_rate || 0);

    return cgst === 0 && sgst === 0 && igst === 0;
});

// if (gstMissingRows.length > 0) {
//     missingFields.push(
//         "GST is mandatory. Some rows do not have CGST / SGST / IGST"
//     );
// }


const invalidGstRows = modifiedRows.filter(row => {
    const cgst = Number(row.cgst_rate || 0);
    const sgst = Number(row.sgst_rate || 0);
    const igst = Number(row.igst_rate || 0);

    // CGST alone ❌
    if (cgst > 0 && sgst === 0) return true;

    // SGST alone ❌
    if (sgst > 0 && cgst === 0) return true;

    // Mixing IGST with CGST/SGST ❌
    if (igst > 0 && (cgst > 0 || sgst > 0)) return true;

    return false;
});

// if (invalidGstRows.length > 0) {
//     missingFields.push(
//         "Invalid GST combination. Use CGST+SGST (intra-state) or IGST only (inter-state)."
//     );
// }


if (gstMissingRows.length > 0) {
    missingFields.push(
        "GST is mandatory. Please enter CGST+SGST or IGST."
    );
} else if (invalidGstRows.length > 0) {
    missingFields.push(
        "Invalid GST combination. Use CGST+SGST (intra-state) or IGST only (inter-state)."
    );
}



        if (missingFields.length > 0) {
            const formattedMessage = `Please fill the following fields:\n${missingFields.map(f => `${f}`).join(',\n')}`;
            callMessage('warning', formattedMessage, 'Mandatory Fields');

            return;
        }


        const requestBody = {
            p_companyid: Number(localStorage.getItem('companyid')),
            p_plantid: 1,
            p_mode: mode_id,
            p_id_enquiry: vendorEnquiryDet[0]?.id_enquiry_hdr,
            p_enquiryitem_list: modifiedRows, // line-level only
            p_id_party: selectedPartyID,
            p_response_date: requestDate ? requestDate.format('YYYY-MM-DD') : null,
            p_remarks: storeNotes,
            p_user: localStorage.getItem('userID'),
            p_id_response_hdr: id_request,
            p_id_purchase: selectedRequestIndentNumberListID,


            p_expiry_delivery_date: expectedDeliveryDate
                ? dayjs(expectedDeliveryDate).format('YYYY-MM-DD')
                : null,


            p_id_payment_terms: paymentTermsID || null,
            p_id_discount: discountID || null,
            p_id_tcs: tcsID || null,
            p_id_tds: tdsID || null,

            p_discount_value: Number(discount?.value || 0),
            p_tax_value: Number(0),
            p_tcs_value: Number(0),
            p_tds_value: Number(tds?.value || 0),

            p_fright: freight || null
        };

        const result = await processIndent(selectedMode, editPurchaseIndentID, requestBody);
        if (result === 'New Vendor Quotation Created Successfully') {

            callMessage('success', result, 'Success');
            clearAllFields();
            setIsDisabled2(true);
            callback();


        }
        else if (result === 'Vendor Quotation updated Successfully') {
            callMessage('info', result, 'Info');
        }
        else {
            callMessage('error', result, 'Error');
        }

    };



    const handlecallbacktoVendorQuotation = () => {
        setOpenVendorQuotation(true);
        setOpenVendorCompareQuotation(false);
    }





    const handlePurchaseIndentChange = async (newValue) => {

        if (!newValue) {
            setSelectedRequestIndentNumberList(null);
            setSelectedRequestIndentNumberListID(null);

            setvendorEnquiryDet([]);
            setFilteredParties([]);
            setIsPartyDisabled(true);

            setSelectedParty(null);
            setSelectedPartyID(null);

            setTableRows([{
                id_material: 0,
                material_code: '',
                material_description: '',
                quantity_required: 0,
                quoted_price: 0,
                party_name: '',
                delivery_date: '',
                payment_terms: 0,
                rating: '',
                id_party: 0,
                status: 'pending'
            }]);

            return;
        }

        // 🟢 selected
        setSelectedRequestIndentNumberList(newValue);
        setSelectedRequestIndentNumberListID(newValue.id_request);

        // 1️⃣ Load enquiry details
        const enquiryData = await loadVendorEnquiryDet(newValue.id_request);

        if (!enquiryData || enquiryData.length === 0) return;

        // 2️⃣ Filter parties
        const filtered = partyList.filter(p =>
            enquiryData[0].party_ids.includes(p.id)
        );

        setFilteredParties(filtered);
        setIsPartyDisabled(false);

        // 3️⃣ Load vendor quotation
        loadVendorDetailByVendorID(
            enquiryData[0].id_enquiry_hdr,
            editresponsehdrid
        );
    };


    const clearAllFields = () => {
        setSelectedDepartment(null);
        setSelectedDepartmentID(null);
        loadVenodrIDByDepartmentID(null, 'vendor enquiry');
        loadIndentNumbersByDepartmentID(null, 'vendor enquiry', selectedRequestIndentNumberListID);
        setSelectedParty(null);
        setSelectedPartyID(null);
        //setTableRows([{ id_material: 0, material_code: '', material_description: '', quantity_required: 0, quoted_price: 0, party_name: '', delivery_date: '', payment_terms: 0, rating: '', id_party: 0, status: 'pending' }]);
        setTableRows([{ id_material: 0, material_code: '', material_description: '', quantity_required: 0, quoted_price: 0, party_name: '', delivery_date: '', payment_terms: 0, cgst_rate: 0, cgst_amount: 0, sgst_rate: 0, sgst_amount: 0, igst_rate: 0, igst_amount: 0, amount: 0, total: 0, rating: '', id_party: 0, status: 'pending' }]);
        setStoreNotes('');
        setvendorEnquiryDet([]);
        editPurchaseIndentID = null;
        hasLoadedVendorDetails.current = false; // prevent future runs
        setRequestDate(dayjs(new Date()));

        setSelectedRequestIndentNumberList(null);


        setFreight('');
        setExpectedDeliveryDate(null);

        setSelectedParty(null);
        setSelectedPartyID(0);

        setPaymentTermsID(null);
        setSelectedPaymentTerm(0);

        setTDSID(0);
        setTds(null);

        setDiscountID(null);
        setDiscount(0);
    };

    useEffect(() => {
        const para = { p_companyid: 1 };

        callApi(
            API_ENDPOINTS.TDS_LIST,
            'POST',
            { 'Content-Type': 'application/json' },
            para
        )
            .then(data => {
                if (data?.length) {
                    settdsOptions(data);


                }
            })
            .catch(err => alert('error', err.message, 'Error'));
    }, []);

    const calculateAmount = (quantity, rate, cgstRate, sgstRate, igstRate) => {
        const qty = parseFloat(quantity) || 0;
        const unitRate = parseFloat(rate) || 0;
        const base = qty * unitRate;

        const cgst = (base * (parseFloat(cgstRate) || 0)) / 100;
        const sgst = (base * (parseFloat(sgstRate) || 0)) / 100;
        const igst = (base * (parseFloat(igstRate) || 0)) / 100;

        return (base + cgst + sgst + igst).toFixed(2);
    };

    const handleTaxRateChange = (index, field, value) => {
        const updatedRows = [...tableRows];


        updatedRows[index][field] = value;

        const row = updatedRows[index];
        const amount = parseFloat(row.amount) || 0;

        row.cgst_amount = ((amount * (parseFloat(row.cgst_rate) || 0)) / 100).toFixed(2);
        row.sgst_amount = ((amount * (parseFloat(row.sgst_rate) || 0)) / 100).toFixed(2);
        row.igst_amount = ((amount * (parseFloat(row.igst_rate) || 0)) / 100).toFixed(2);

        const quantity = parseFloat(row.quantity_required) || 0;
        const rate = parseFloat(row.quoted_price) || 0;

        row.amount = (quantity * rate);
        row.total = calculateAmount(quantity, rate, row.cgst_rate, row.sgst_rate, row.igst_rate);
        setTableRows(updatedRows);
    };


    const handlecallProcess = (buttonName) => {
        if (buttonName === 'CreateQuoteComparison') {
            setOpenVendorQuotation(false);
            setOpenVendorCompareQuotation(true);

        }

    };

    return (
        <>

            {openVendorQuotation && (
                <Box padding={0}>

                    <Header title={editPurchaseIndentID === 0 ? 'New Supplier Quotation' : 'Edit Supplier Quotation'} subtitle="" callback={callback} />
                    <Divider />

                    {editPurchaseIndentID > 0 && (
                        <>
                            <VendorResponseSubMenuNew selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} selectedQuoteDetails={selectedQuoteDetails} />
                            <Divider />
                        </>
                    )}

                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            px: 1,
                            py: 1
                        }}
                    >
                        <Typography variant="h6"  >
                            <span style={{ color: 'red' }}>*</span> Mandatory fields
                        </Typography>
                    </Box>

                    <Grid container>
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography
                                        variant="h6"
                                        fontSize={14}
                                        marginTop={0}
                                        textAlign="left"
                                    >
                                        Department <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>

                                </Grid>

                                <Grid item xs={12} sm={11} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}
                                        disabled={isDisabled}
                                        onChange={(event, newValue) => {
                                            if (newValue === null) {
                                                clearAllFields();
                                                return;
                                            }
                                            setSelectedDepartment(newValue);
                                            setSelectedDepartmentID(newValue.id);
                                            loadVenodrIDByDepartmentID(newValue.id, 'vendor enquiry');
                                            loadIndentNumbersByDepartmentID(newValue.id, 'vendor enquiry', selectedRequestIndentNumberListID);

                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField color="secondary" {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Purchase Indent # <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>

                                    <Autocomplete
                                        size="small"
                                        color="secondary"
                                        fullWidth
                                        disabled={isDisabled}
                                        options={requestIndentNumberList}
                                        value={selectedRequestIndentNumberList}
                                        onChange={(event, newValue) => {
                                            handlePurchaseIndentChange(newValue);
                                        }}
                                        getOptionLabel={(option) => option.request_indent_number || ''}
                                        renderInput={(params) => (
                                            <TextField
                                                color="secondary"
                                                {...params}
                                                label=""
                                                required
                                                variant="outlined"
                                            />
                                        )}
                                    />

                                    {/* <Autocomplete
                                        size="small"
                                        color="secondary"
                                        fullWidth
                                        disabled={isDisabled}
                                        options={requestIndentNumberList}
                                        value={selectedRequestIndentNumberList}
                                        onChange={(event, newValue) => {
                                            if (newValue === null) {
                                                setSelectedRequestIndentNumberList(null);
                                                setSelectedRequestIndentNumberListID(null);
                                                getRequestDetailByRequestID(null);
                                                loadVendorEnquiryDet(null);
                                                setvendorEnquiryDet([]);
                                                setTableRows([{ id_material: 0, material_code: '', material_description: '', quantity_required: 0, quoted_price: 0, party_name: '', delivery_date: '', payment_terms: 0, rating: '', id_party: 0, status: 'pending' }]);
                                                return;
                                            }
                                            setSelectedRequestIndentNumberList(newValue);
                                            setSelectedRequestIndentNumberListID(newValue.id_request);
                                            getRequestDetailByRequestID(newValue.id_request);
                                            loadVendorEnquiryDet(newValue.id_request);


                                        }}
                                        getOptionLabel={(option) => option.request_indent_number || ''}
                                        renderInput={(params) => (
                                            <TextField color="secondary" {...params} label="" required variant="outlined" />
                                        )}
                                    /> */}
                                </Grid>

                                {vendorEnquiryDet?.length > 0 && (
                                    <Grid item xs={12} sm={12} md={5} lg={5} xl={5} display="flex" justifyContent="flex-start" alignItems="center">
                                        <Typography variant="h5" fontSize={14} fontStyle={'bold'}>
                                            ( {`Enquiry ID / Date : ${vendorEnquiryDet[0]?.id_enquiry_hdr || '--'} / ${vendorEnquiryDet[0]?.enquiry_date
                                                ? dayjs(vendorEnquiryDet[0].enquiry_date).format('DD-MMM-YYYY')
                                                : '--'
                                                }`} )
                                        </Typography>
                                    </Grid>
                                )}

                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >

                            <Grid container padding="10px 0px 0px 20px" alignItems="center" >

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Party Name  <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        disabled={isPartyDisabled}
                                        options={filteredParties} // 👈 only filtered list
                                        value={selectedParty}
                                        onChange={(event, newValue) => {
                                            setSelectedParty(newValue);
                                            setSelectedPartyID(newValue?.id || null);

                                            // 🔥 THIS is the trigger now
                                            prepareTableRowsByParty(newValue);
                                        }}
                                        getOptionLabel={(option) =>
                                            (option && typeof option === 'object' && option.companyname)
                                                ? option.companyname
                                                : ''
                                        }
                                        filterOptions={(options, state) => {
                                            return filter(
                                                options.filter(p => p && typeof p === 'object' && typeof p.companyname === 'string'),
                                                state
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" color="secondary" required variant="outlined" />
                                        )}
                                        renderOption={(props, option) => (
                                            <Box sx={{ backgroundColor: colors.primary[400] }} component="li" {...props} display="flex" alignItems="center">
                                                <Avatar src={option.avatarUrl} alt={option.companyname} sx={{ marginRight: 2 }} />
                                                <Box display="flex" flexDirection="column">
                                                    <Typography variant="subtitle2" component="div">
                                                        {option.companyname}
                                                    </Typography>
                                                    <Box display="flex" justifyContent="space-between" width="100%">
                                                        <Box display="flex" alignItems="center">
                                                            <EmailIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                                            <Typography variant="body2" color="textSecondary">
                                                                {option.email}
                                                            </Typography>
                                                        </Box>
                                                        <Divider orientation="vertical" flexItem sx={{ marginX: 1 }} />
                                                        <Box display="flex" alignItems="center">
                                                            <BusinessIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                                                            <Typography variant="body2" color="textSecondary">
                                                                {option.name}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid mt={2} mb={1} item xs={12} xl={12} >



                            <Divider />
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Response Date <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                disabled={isDisabled}
                                                id="Orderdate"
                                                format="DD-MMM-YYYY"
                                                value={dayjs(requestDate)}
                                                minDate={editPurchaseIndentID === 0 ? today : undefined}
                                                // disabled={editRequestIndentID !== 0}
                                                onChange={(date) => setRequestDate(date)}
                                                slotProps={{ textField: { size: 'small', color: 'secondary' } }}
                                                fullWidth
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField fullWidth required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                                <Grid ml={4} item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Freight <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={['To Pay', 'Paid']}
                                        value={freight}
                                        onChange={(event, newValue) => {
                                            setFreight(newValue ?? null); // fallback to null if needed
                                        }}

                                        renderInput={(params) => (
                                            <TextField
                                                color="secondary"
                                                {...params}
                                                placeholder="Select Freight Option"
                                                variant="outlined"
                                            />
                                        )}

                                    />
                                </Grid>


                            </Grid>
                        </Grid>



                        <Grid item xs={12} xl={12} >

                            <Grid container padding="10px 0px 10px 20px" alignItems="center" >



                                <Grid item xs={12} sm={11} md={1.6} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Delivery Date <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="Orderdate"

                                                minDate={editPurchaseIndentID === 0 ? today : undefined}

                                                value={
                                                    dayjs(expectedDeliveryDate).isValid()
                                                        ? dayjs(expectedDeliveryDate)
                                                        : null
                                                }
                                                onChange={(date) => setExpectedDeliveryDate(date)}
                                                slotProps={{ textField: { size: 'small', color: 'secondary' } }}
                                                fullWidth
                                                format="DD-MMM-YYYY"
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField fullWidth required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>

                                </Grid>



                                <Grid ml={4} item xs={12} sm={11} md={1.6} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Payment Terms <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <CustomAutocomplete
                                        label="Payment Term"
                                        options={paymentTerms}
                                        selectedOption={selectedPaymentTerm}
                                        setSelectedOption={setSelectedPaymentTerm}
                                        setAnchorEl={setPaymentTermAnchorEl}
                                        anchorEl={paymentTermAnchorEl}
                                        handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                                        handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                                        filterText={paymentTermFilterText}
                                        setFilterText={setPaymentTermFilterText}
                                        handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                                        handleAddOption={handleAddOption('Payment Term')}
                                        selectedID={paymentTermsID}
                                        setSelectedID={setPaymentTermsID}
                                        isRequired={true}
                                    />

                                </Grid>

                            </Grid>

                        </Grid>


                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                <Grid item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Discount
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        freeSolo
                                        options={discounts}
                                        value={discount}
                                        inputValue={inputValue}

                                        onInputChange={(event, newInputValue) => {

                                            const regex = /^\d*\.?\d*%?$/;
                                            if (regex.test(newInputValue)) {
                                                setInputValue(newInputValue);
                                            }
                                        }}
                                        getOptionLabel={(option) => {
                                            if (typeof option === 'string') return option;
                                            if (typeof option === 'object' && option !== null) return option.description || '';
                                            return '';
                                        }}
                                        onChange={(event, newValue) => {
                                            if (typeof newValue === 'string') {
                                                setDiscount({ id: null, description: newValue });
                                                setDiscountID(null);
                                                setInputValue(newValue); // keep inputValue in sync
                                            } else if (newValue && typeof newValue === 'object') {
                                                setDiscount(newValue);
                                                setDiscountID(newValue.id);
                                                setInputValue(newValue.description); // sync with selected object
                                            } else {
                                                setDiscount(null);
                                                setDiscountID(null);
                                                setInputValue('');
                                            }
                                        }}
                                        onBlur={(e) => {
                                            if (inputValue?.trim()) {
                                                const cleanedValue = inputValue.trim().replace(/%$/, ''); // remove trailing %
                                                setDiscount({ id: null, description: inputValue, value: parseFloat(cleanedValue) });
                                                // setDiscountID(null);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label="Discount"
                                                variant="outlined"
                                                fullWidth
                                                color="secondary"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid ml={4} item xs={12} sm={11} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center" >
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        TDS <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>

                                    <Autocomplete
                                        size="small"
                                        fullWidth

                                        options={tdsOptions} // You need to define this array like discounts/tcsOptions
                                        value={tds}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(event, newValue) => {
                                            setTds(newValue);
                                            setTDSID(newValue.id); // Optional
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}

                                                variant="outlined"
                                                color="secondary"
                                            />
                                        )}
                                    />


                                </Grid>


                            </Grid>

                        </Grid>






                        {/* <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Enquiry ID & Date
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={vendorIDList}
                                        value={selectedVendoIdList}
                                        onChange={(event, newValue) => {
                                            setSelectedVendoIdList(newValue);
                                            setSelectedVendoIdListID(newValue?.id_enquiry); // optional chaining in case newValue is null
                                            // loadVenodrListByEnquiryIDLocal(newValue?.id_enquiry, 'vendor enquiry', selectedRequestIndentNumberListID);
                                            loadVendorDetailByVendorID(newValue?.id_enquiry, newValue?.id_enquiry);
                                        }}
                                        getOptionLabel={(option) =>
                                            option && option.id_enquiry && option.enquiry_date
                                                ? `${option.id_enquiry} / ${option.enquiry_date}`
                                                : ''
                                        }
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid> */}



                        <Grid item xs={12} lg={12} xl={10} mt={3} mr={2} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                                    <CustomTableContainer colors={colors}>
                                        <TableContainer>
                                            <Table sx={{ tableLayout: 'auto' }}>

                                                <TableHead>
                                                    <TableRow>
                                                        {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', minWidth: 140, whiteSpace: "nowrap" }}>Party Name</TableCell> */}
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 'auto', whiteSpace: "nowrap" }}>Material</TableCell>

                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right', minWidth: 120, whiteSpace: "nowrap" }}>Required Quantity</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right', minWidth: 120, whiteSpace: "nowrap" }}>Vendor Offered Qty.</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', minWidth: 80, whiteSpace: "nowrap" }}>Quoted Price (per unit)</TableCell>
                                                        {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', minWidth: 150, whiteSpace: "nowrap" }}>Delivery Date</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', }}>Payment term (in days)</TableCell> */}
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Amount</TableCell>
                                                        <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>CGST</TableCell>
                                                        <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>SGST</TableCell>
                                                        <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>IGST</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Total</TableCell>

                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', width: 40 }}>Rating</TableCell>
                                                        {/* <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>PO No.</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>PO Qty.</TableCell> */}
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center', }}>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => {
                                                        const editable = isRowEditable(row.status);
                                                        return (

                                                            <TableRow key={index}>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <Box
                                                                        sx={{
                                                                            px: 1,
                                                                            whiteSpace: 'nowrap',
                                                                            fontSize: '14px'
                                                                        }}
                                                                    >
                                                                        {row.material_code} | {row.material_description}
                                                                    </Box>

                                                                </TableCell>


                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.quantity_required}
                                                                        disabled
                                                                    />
                                                                </TableCell>


                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        disabled={!editable}
                                                                        value={row.vendor_offered_qty}
                                                                        onChange={(e) => handleVendorOfferedQuantityChange(index, e.target.value)}
                                                                    />
                                                                </TableCell>


                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        disabled={!editable}
                                                                        value={row.quoted_price}
                                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "150px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        value={row.amount}
                                                                        variant="outlined"
                                                                        disabled
                                                                    />
                                                                </TableCell>




                                                                {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <Stack spacing={2}>
                                                                            <DatePicker
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiSelect-select': {
                                                                                        padding: '0px',
                                                                                    },
                                                                                }}
                                                                                size="small"
                                                                                format="DD-MMM-YYYY"
                                                                                id="Orderdate"
                                                                                disabled={!editable}
                                                                                value={row.delivery_date ? dayjs(row.delivery_date) : null} // Convert to dayjs
                                                                                onChange={(date) => handleDateChange(index, date)} // Pass correct parameters
                                                                                slotProps={{ textField: { size: 'small' } }}
                                                                                fullWidth
                                                                                className="customDatePicker"
                                                                                renderInput={(props) => (
                                                                                    <TextField required {...props} />
                                                                                )}
                                                                            />
                                                                        </Stack>
                                                                    </LocalizationProvider>
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        disabled={!editable}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.payment_terms}
                                                                        onChange={(e) => handleRemarksChange(index, e.target.value)}
                                                                    />
                                                                </TableCell> */}

                                                                <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        value={row.cgst_rate}
                                                                        onChange={(e) => handleTaxRateChange(index, 'cgst_rate', e.target.value)}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        disabled={!editable}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        value={row.cgst_amount}
                                                                        disabled
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        value={row.sgst_rate}
                                                                        disabled={!editable}
                                                                        onChange={(e) => handleTaxRateChange(index, 'sgst_rate', e.target.value)}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        value={row.sgst_amount}
                                                                        disabled
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        type="number"
                                                                        value={row.igst_rate}
                                                                        disabled={!editable}
                                                                        onChange={(e) => handleTaxRateChange(index, 'igst_rate', e.target.value)}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        size="small"
                                                                        value={row.igst_amount}
                                                                        type="number"
                                                                        disabled
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}

                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", minWidth: "200px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        value={row.total}
                                                                        variant="outlined"
                                                                        disabled
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'center',
                                                                                fontWeight: 'bold',
                                                                                color: 'green'
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="text"
                                                                        value={row.rating || ''}
                                                                        disabled
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ border: '1px solid black', padding: 2 }}>
                                                                    <Chip
                                                                        label={getStatusStyle(row.status).label}
                                                                        size="small"
                                                                        sx={{
                                                                            backgroundColor: getStatusStyle(row.status).bg,
                                                                            color: getStatusStyle(row.status).color,
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    />
                                                                </TableCell>



                                                                {/* <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'center',
                                                                            fontWeight: 'bold',
                                                                            color: 'green'
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="text"
                                                                    value={row.po_number || ''}
                                                                    disabled
                                                                />
                                                            </TableCell>

                                                            <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                <TextField
                                                                    fullWidth
                                                                    size="small"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            border: 'none',
                                                                        },
                                                                        '& .MuiInputBase-input': {
                                                                            padding: '8px',
                                                                            textAlign: 'right',
                                                                            fontWeight: 'bold',
                                                                            color: 'green'
                                                                        },
                                                                    }}
                                                                    variant="outlined"
                                                                    type="number"
                                                                    value={row.vendor_assign_quantity || 0}
                                                                    disabled
                                                                />
                                                            </TableCell> */}
                                                            </TableRow>);
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </CustomTableContainer>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
                            <Box padding={1} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderColor: 'divider',
                                borderRadius: 2,
                                color: 'text.secondary', '& svg': { m: 1, },
                            }} >
                                <Grid container spacing={0}>
                                    <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                                        <Typography variant="h5" fontWeight="bold">Notes </Typography>
                                        <Grid mt={.5} item xs={12} lg={12} xl={10}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                value={storeNotes}
                                                onChange={(e) => setStoreNotes(e.target.value)}
                                                color="secondary"
                                                multiline
                                                rows={4}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                    </Grid>


                    <Grid container mt={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                                <Toolbar>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleSaveAndDraft}
                                        color="secondary"
                                        startIcon={<SaveAltIcon />}
                                        sx={{ marginLeft: 'auto', textTransform: 'none' }}
                                        disabled={isDisabled || isDisabled2}
                                    >
                                        Save
                                    </Button>
                                    <Button size="small" variant="contained" onClick={clearAllFields} style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Clear</Button>
                                </Toolbar>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>

            )}

            {(openVendorCompareQuotation) && (
                <AddCompareVendorQuotations handlecallback={handlecallbacktoVendorQuotation}
                    quotationData={0} para_selectedDepartment={selectedDepartment}
                    para_selectedPurchaseIndentNo={selectedRequestIndentNumberList}
                    fromVendorResponseUI={true}
                />


            )}
        </>

    );
};

export default AddVendorReponseNew;
